import { useRef, useState } from "react";
import QuickApplyEducation from "@components/quick_apply/education_section.tsx";
import type { Education } from "@components/quick_apply/education_section.tsx";
import { validateEducations, type EducationErrors } from "@components/quick_apply/util.ts";
import ModalFooter from "./modal_footer.tsx";
import useSectionSave from "./use_section_save.ts";
import type { SectionProps } from "./types.ts";

const seedEducations = (data: SectionProps["data"]): Education[] =>
  data.educations.map((education) => ({ ...education, key: crypto.randomUUID().toString() }));

const EducationSection = ({ data, onClose }: SectionProps) => {
  const { save, saving } = useSectionSave();
  const [educations, setEducations] = useState<Education[]>(() => seedEducations(data));
  const [educationsError, setEducationsError] = useState<EducationErrors>({});
  const educationRefs = useRef<HTMLElement[]>([]);

  const handleSave = async () => {
    const validationErrors = validateEducations(educations);
    if (Object.keys(validationErrors).length > 0) {
      setEducationsError(validationErrors);
      return;
    }

    const formData = new FormData();
    formData.append("educations", JSON.stringify(educations));

    if (await save(formData)) onClose();
  };

  return (
    <>
      <QuickApplyEducation
        educations={educations}
        setEducations={setEducations}
        educationsError={educationsError}
        educationPath="/education"
        educationRefs={educationRefs}
      />
      <ModalFooter section="education" onSave={handleSave} onCancel={onClose} saving={saving} />
    </>
  );
};

export default EducationSection;
